import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Renderable, RenderEventListener, SubmitEventListener } from '@philips-emr/tws-core/lib/component/types';

import { HpmsCustomCardEventListener, HpmsCustomCardMenuRenderEventListener, HpmsCustomCardType } from '../../types';
import { CustomCardType } from '../../types/custom-card-type';

export const DYNAMIC_CONTENT_TYPE = 'hpms-custom-card-dynamic-content';
export const ACTION_TYPE = 'hpms-custom-card-action';

export default class HpmsCustomCardApi extends ComponentAPI<CustomCardType> implements HpmsCustomCardType<Record<string, Value>>, Renderable {
  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onCreateOption = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onOptionClick = new HpmsCustomCardEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onCreateMenu = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onRenderAction = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onSubmitCard = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onClickHeader = new HpmsCustomCardEventListener<Record<string, Value>>();

  @AwesomeEvent
  onOpen = new HpmsCustomCardEventListener<Record<string, Value>>();

  setEditing(editing: boolean): void {
    this.setState({ ...this.state, editing });
  }

  getEditing(): boolean {
    return this.state.editing;
  }

  public isCollapsed(): boolean {
    return this.collapsed;
  }

  public setCollapsed(value: boolean): void {
    this.setState({ collapsed: value });
  }

  public getData(): Record<string, Value> {
    return this.state.data;
  }
}
